import { useEffect,useState } from 'react'

import { AxiosError } from 'axios'

import { fetchSalesforceAttributeDefs } from 'api'

const useSalesforceAttributeDefs = () => {
	const [salesforceAttributeDefs, setSalesforceAttributeDefs] = useState<any>(null)
	const [error, setError] = useState<AxiosError | null>(null)

  useEffect(() => {
    const fetchAttributes = async () => {
      try {
        const { data } = await fetchSalesforceAttributeDefs()
				const salesforceData = data.find(({ cardName }: any) => cardName === 'Salesforce Attributes')
				setSalesforceAttributeDefs(salesforceData?.attributes)
      } catch (error) {
        setError(error as AxiosError)
      }
    }
    fetchAttributes()
  }, [])
  return { salesforceAttributeDefs, error }
}

export default useSalesforceAttributeDefs
